<div class="row d-flex justify-content-between">
  <div class="col-md-4 divSearch ">
    <app-search [list]="AllItems" [OriginalList]="FilteredItems" [column]="'name'"
      (newItemEvent)="GetFilteredList($event)"></app-search>

  </div>
  <div class="col-md-4 form-field-normal align-content-center">
    <mat-form-field appearance="outline" class="w-50 m-b-sm" subscriptSizing="dynamic">
      <mat-select [value]="selectedSupplier" placeholder="Supplier" (valueChange)="ChangeSupplier($event)">
        <mat-option value=""> {{ 'Select' | translate }}</mat-option>
        <mat-option [value]="cat" *ngFor="let cat of AllSuppliers">{{ cat.nameAgent }}
        </mat-option>
      </mat-select>
      <mat-label>{{ 'Supplier' | translate }}</mat-label>
    </mat-form-field>
  </div>
  <div class="col-md-3 divCreate">
    <a [routerLink]="['/dashboard/add-item']" class="btnCreate btn-icon-group">
      <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
      {{ 'CreateNewItem' | translate}}
    </a>
  </div>
</div>

<div class="count" *ngIf="AllItems?.length!=0">{{'Results'| translate}}: {{AllItems.length}}</div>
<div class="row">
  <div *ngIf="AllItems?.length==0;then NoItems else Items"></div>

  <ng-template #NoItems>
    <div class="col-md-12 text-center">
      <p> {{ 'NoDataFound' | translate }}</p>
    </div>
  </ng-template>

  <ng-template #Items>
    <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let item of AllItems">
      <mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
        <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
          <mat-card-title class="mat-mdc-card-title text-white">{{ item.productName| subString:20 }}</mat-card-title>
          <div class="d-flex divIcons" *ngIf="showEdit">
            <i-tabler name="trash" class="icon-20 d-flex clickIcon" matTooltip="{{'Delete'|translate}}"
              (click)="DeleteItem(item.productId)"></i-tabler>
            <i-tabler name="edit" class="icon-20 d-flex clickIcon" matTooltip="{{'Edit'|translate}}"
              (click)="EditItem(item.productId)"></i-tabler>
            <i-tabler name="eye" class="icon-20 d-flex clickIcon" matTooltip="{{'View'|translate}}"
              (click)="ViewItem(item.productId)"></i-tabler>
          </div>
        </mat-card-header>
        <img alt="{{item.productName}}" width="50%" height="50%" class="mat-mdc-card-image mdc-card__media"
          src="{{item.imgURL | adjust_image_path}}" (click)="ShowImage(item)">
        <mat-card-content class="mat-mdc-card-content p-y-24">

          <ul>
            <li><span class="bold">{{'Color'|translate}} : </span><span>{{item?.colorName}} </span></li>
            <li><span class="bold">{{'Category'|translate}} : </span><span>{{item?.categoryName}} </span></li>
            <li><span class="bold">{{'metersPerRod'|translate}} : </span>
              <span>{{item?.metersPerRod??1}} {{ 'Meter'|translate }}</span>
            </li>
            <li><span class="bold">{{'pricePerOne'|translate}} : </span>
              <span>{{item?.pricePerOne}} {{ 'EGP' | translate}}</span>
            </li>
            <li><span class="bold">{{'TotalQuota'|translate}} : </span><span>{{item?.totalQuota}} </span></li>
            <li><span class="bold">{{'measruingUnit'|translate}} : </span><span>{{item?.typeOfProductName}} </span></li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-template>
</div>
